fx.ns("filters", class BackgroundFilter extends fx.Filter {

	constructor()
	{
        super();

        this._search = "";
    }


    get search()
    {
        return this._search;
    }

    set search(val)
    {
        this._search = val;
    }


	exec()
	{
        if (!this.rawData)
            return;

        let adminMode = fx.get("app") == "config";

        this.transformedData = [];
        let projectTagAdded = false,
            searchTagAdded = false;
        let themeCategoryTagAdded = false;
        let backgroundsUsed = [];
        let backgroundCollection = [];

        
        for (let i = 0; i < this.rawData.length; i++)
        {
            let background = this.rawData.getItemAt( [i] );

            // On search, we display return all backgrounds
            if (this.search != "")
            {
                if (!searchTagAdded)
                {
                    this.transformedData.push( {type : "label", text : fx.text('Recherche') + ' : "' + this.search + '"'}  );
                    searchTagAdded = true;
                }
                
                if (background.visible || background.available || adminMode)
                    this.transformedData.push( background );
            }
            else // if not search, we display first used backgrounds, and then theme_category ones
            {
                if ( background.number > 0)
                {
                    if (!projectTagAdded)
                    {
                        backgroundsUsed.push( {type : "label", text : fx.text("Fonds utilisés")}  );
                        projectTagAdded = true;
                    }

                    if (background.visible || background.available || adminMode)
                        backgroundsUsed.push( background );
                }
                else
                {
                    if (!themeCategoryTagAdded)
                    {
                        backgroundCollection.push( {type : "label", text : fx.text("Fonds recommandés")}  );
                        themeCategoryTagAdded = true;
                    }

                    if ((background.visible || background.available || adminMode) && !backgroundCollection.find({id : background.id}))
                        backgroundCollection.push( background );
                }

            }
        }

        if (this.search == "")
        //{
            //if (backgroundCollection.length > 0)
            if (backgroundsUsed.length > 0)
                this.transformedData = backgroundsUsed.concat(backgroundCollection);
            else
                this.transformedData = backgroundCollection;
            //else
                //this.transformedData = backgroundsUsed;
        //}

        if (this.search != "" && this.transformedData.length == 0)      
            this.transformedData.push( {type : "label", text : fx.text('Aucun résultat pour') + ' "' + this.search + '"'}  );

        this.transformedData.more = this.rawData.more;

		return this.transformedData;
	}	
});